import { CreateUserPayload, UserProfileResponse, UserRole } from '@shared/interfacres/user';


export interface UserDataFormValue {
  firstName: string;
  lastName: string;
  stageName: string;
  performanceType: string[];
  performanceLocations1: string;
  performanceLocations2: string;
  performanceLocations3: string;
  website: string;
  instagram: string;
  facebook: string;
  weeklyPerformances: number;
}

export const mapFormToPayload = (formData: UserDataFormValue): Partial<CreateUserPayload> => {
  return {
    firstName: formData?.firstName || '',
    lastName: formData?.lastName || '',
    stageName: formData?.stageName || '',
    performanceType: formData?.performanceType || [],
    performanceLocations: [
      formData?.performanceLocations1,
      formData?.performanceLocations2,
      formData?.performanceLocations3
    ].filter(item => item && item !== '') as string[],
    weeklyPerformances: formData?.weeklyPerformances ? +formData?.weeklyPerformances :  0,
    socialLinks: {
      website: formData?.website || '',
      instagram: formData?.instagram || '',
      facebook: formData?.facebook || '',
    },
  };
}

export const mapToUserProfile = (user: UserProfileResponse) => {
  return {
    id: user.id,
    email: user.email,
    role: user.role === 'admin' ? UserRole.Admin : UserRole.Authenticated,
    firstName: user.firstName,
    lastName: user.lastName,
    stageName: user.stageName,
    // performanceType: user.performanceType,
    performanceType: user.performanceType,
    performanceLocations: user.performanceLocations,
    weeklyPerformances: user.weeklyPerformances,
    socialLinks: {
      website: user.socialLinks.website || '',
      instagram: user.socialLinks.instagram || '',
      facebook: user.socialLinks.facebook || '',
    },
    subscriptionStatus: user.subscriptionStatus
  }
}
